import React, { useState, useEffect } from "react";
import { Card, Table, Button, Typography, Tag, Tooltip } from "antd";
import { CheckCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { flushSync } from "react-dom";
const { Title } = Typography;

/**
 * Component to display and select from available segments
 * When a segment is selected, it automatically fills the form in FormLayout
 */
const SegmentSelectionBlock = ({
  segmentAllOptions,
  selectedSegment,
  setSelectedSegment,
  selectedList,
  setSelectedList,
  AlllistOptions,
  setListAndSegment,
  campaigns,
}) => {
  const [availableSegments, setAvailableSegments] = useState([]);
  
  // Load available segments for the current campaign from localStorage
  useEffect(() => {
    console.log("campaigns 9", campaigns)
  }, [campaigns]);
  useEffect(() => {
    try {
      // Prefer campaign-based storage
      const savedCampaignSegments = localStorage.getItem('campaignSegments');
      console.log("savedCampaignSegments", savedCampaignSegments, campaigns);
      if (savedCampaignSegments) {
        const store = JSON.parse(savedCampaignSegments);
        console.log("store", store);
        let segments = [];
        if (campaigns?.length) {
          // 1) Try direct key by campaign.id
          const byId = store?.[campaigns[0].id];
          console.log("byId", byId, campaigns[0].id, campaigns[0].code);
          if (byId) {
            segments = Array.isArray(byId) ? byId : (byId.segments || []);
          } else {
            // 2) Try match by campaign.code against each entry's campaign_code
            for (const key of Object.keys(store)) {
              const entry = store[key];
              if (!entry) continue;
              if (!Array.isArray(entry) && entry.campaign_code && entry.campaign_code === campaigns[0].code) {
                segments = Array.isArray(entry.segments) ? entry.segments : [];
                break;
              }
            }
          }
        }
        console.log("segments!1", segments);
        if (segments.length > 0) {
          setAvailableSegments(segments);
          return;
        }
      }
      // Fallback to legacy storage
      const savedSegments = localStorage.getItem('selectedSegments');
      if (savedSegments) {
        const parsedSegments = JSON.parse(savedSegments);
        setAvailableSegments(parsedSegments || []);
      } else {
        setAvailableSegments([]);
      }
    } catch (error) {
      console.error('Error loading segments from localStorage:', error);
      setAvailableSegments([]);
    }
  }, [campaigns]);

  const handleSelectSegment = (segment) => {
    const listOption = AlllistOptions.find(o => o.label === segment.list_name);
    if (!listOption) return;
  
    // 1) Apply list immediately (no batching)
    flushSync(() => {
      setSelectedList(listOption);
    });
  
    // 2) Now the UI/state reflects the new list—set segment
    const segmentOption = segmentAllOptions.find(o => o.label === segment.segment_name);
    setSelectedSegment(segmentOption || null);
  };
  

  // Define table columns
  const columns = [
    {
      title: "List Name",
      dataIndex: "list_name",
      key: "list_name",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Segment Name",
      dataIndex: "segment_name",
      key: "segment_name",
      render: (text) => <span>{text || "N/A"}</span>,
    },
    {
      title: "Mailed Qty",
      dataIndex: "mailed_quantity",
      key: "mailed_quantity",
      render: (text) => <span>{text?.toLocaleString() || "0"}</span>,
    },
    {
      title: "Gross Orders",
      dataIndex: "gross_orders",
      key: "gross_orders",
      render: (text) => <span>{text?.toLocaleString() || "0"}</span>,
    },
    {
      title: "Gross %",
      dataIndex: "gross_percentage",
      key: "gross_percentage",
      render: (text) => <span>{((parseFloat(text) || 0) * 100).toFixed(2) + "%"}</span>,
    },
    {
      title: "Net P/L",
      dataIndex: "net_profit_loss",
      key: "net_profit_loss",
      render: (text) => (
        <Tag color={parseFloat(text) > 0 ? "green" : "red"}>
          ${parseFloat(text || 0).toFixed(2)}
        </Tag>
      ),
    },
    {
      title: "Net P/L per Buyer",
      dataIndex: "net_profit_loss_per_buyer",
      key: "net_profit_loss_per_buyer",
      render: (text) => (
        <Tag color={parseFloat(text) > 0 ? "green" : "red"}>
          ${parseFloat(text || 0).toFixed(2)}
        </Tag>
      ),
    },
    {
      title: "BE P/L per Buyer",
      dataIndex: "be_pl_per_buyer_ltv",
      key: "be_pl_per_buyer_ltv",
      render: (text) => (
        <Tag color={parseFloat(text) > 0 ? "green" : "red"}>
          ${parseFloat(text || 0).toFixed(2)}
        </Tag>
      ),
    },
    {
      title: "FE P/L per Buyer",
      dataIndex: "fe_pl_per_buyer_ltv",
      key: "fe_pl_per_buyer_ltv",
      render: (text) => (
        <Tag color={parseFloat(text) > 0 ? "green" : "red"}>
          ${parseFloat(text || 0).toFixed(2)}
        </Tag>
      ),
    },
    {
      title: "Delta",
      dataIndex: "delta",
      key: "delta",
      render: (text) => (
        <Tag color={parseFloat(text) > 0 ? "green" : "red"}>
          ${parseFloat(text || 0).toFixed(2)}
        </Tag>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Tooltip title="Select this segment">
          <Button
            type="primary"
            size="small"
            icon={<CheckCircleOutlined />}
            onClick={() => setListAndSegment(record)}
          >
            Select
          </Button>
        </Tooltip>
      ),
    },
  ];

  return (
    <Card 
      title={
        <div style={{ display: "flex", alignItems: "center" }}>
          <Title level={5} style={{ margin: 0 }}>List & Segment Playground</Title>
          <Tooltip title="Select a segment to automatically fill the form below">
            <InfoCircleOutlined style={{ marginLeft: 8 }} />
          </Tooltip>
        </div>
      }
      size="small"
      style={{ marginBottom: 16 }}
    >
      {availableSegments.length > 0 ? (
        <Table
          columns={columns}
          dataSource={availableSegments}
          rowKey={(record) => `${record.list_name}-${record.segment_name}`}
          size="small"
          pagination={{ pageSize: 5 }}
          scroll={{ x: "max-content" }}
        />
      ) : (
        <div style={{ textAlign: "center", padding: "20px 0" }}>
          No segments available. Add segments from the Reports section.
        </div>
      )}
    </Card>
  );
};

export default SegmentSelectionBlock;
